import { render, staticRenderFns } from "./AboutUsHero.vue?vue&type=template&id=5233909e&scoped=true"
import script from "./AboutUsHero.vue?vue&type=script&lang=js"
export * from "./AboutUsHero.vue?vue&type=script&lang=js"
import style0 from "./AboutUsHero.vue?vue&type=style&index=0&id=5233909e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233909e",
  null
  
)

export default component.exports